export const tooltipPlacements = ['top', 'right', 'bottom', 'left'] as const;
export const TOOLTIP_CLASS = 'tooltip-container';
export const TOOLTIP_SELECTOR = `.${TOOLTIP_CLASS}`;
export const TOOLTIP_DEBOUNCE_TIME = 200;

export type Placement = (typeof tooltipPlacements)[number];

export type Options = {
  content: string | null;
  placement?: Placement;
  stayOpenOnHover?: boolean;
};

export type Value = string | null | Options;
